const MIN_QUERY_LENGTH = 3;
const DEBOUNCE_MS = 300;

/**
 * Shared debounce-timer mechanics behind SpeciesSearchWidget/
 * SpeciesGbifSearchField's own search boxes: clears any pending timer,
 * immediately clears results for a query below MIN_QUERY_LENGTH, otherwise
 * (re)schedules runSearch(trimmedQuery) after DEBOUNCE_MS. Owns nothing
 * but `component.debounceHandle` and `component.results` - each caller
 * still owns whatever else needs to happen on every keystroke
 * (SpeciesGbifSearchField's own onclear() call, SpeciesSearchWidget's own
 * showHelp reset) - only the timer+threshold logic was actually
 * duplicated, not each caller's own side effects, so those stay inline at
 * the call site rather than being threaded through here.
 *
 * @param {object} component - the Mithril component instance (must expose
 *   a settable `debounceHandle`/`results`, same as before this helper).
 * @param {string} value - raw input value (not yet trimmed).
 * @param {(query: string) => void} runSearch - called with the trimmed
 *   query once the debounce delay elapses.
 */
export default function debouncedSearch(component, value, runSearch) {
  if (component.debounceHandle) clearTimeout(component.debounceHandle);
  const trimmed = value.trim();
  if (trimmed.length < MIN_QUERY_LENGTH) {
    component.results = [];
    m.redraw();
    return;
  }
  component.debounceHandle = setTimeout(() => runSearch(trimmed), DEBOUNCE_MS);
  m.redraw();
}
flarum.reg.add('champis-species', 'forum/utils/debouncedSearch', debouncedSearch);